var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ 'node-slide-row', _vm.item.classes ]},_vm._l((_vm.item.items),function(column){return _c(column.type,{key:column.index,tag:"component",attrs:{"item":column},on:{"action":_vm.onAction}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }